


import { Component, Vue, Watch } from 'vue-property-decorator';

import SearchAutocomplete from '@/shared/components/SearchAutocomplete.component.vue';

@Component({
    components: {
      SearchAutocomplete,
    },
})

export default class PartialSearchAutocomplete extends Vue {
  private search = '';
  private filteredOptions: any[] = [];
  private searchOptions: any[] = [
    {
      id: '1',
      text: 'Abagael Kaszuba Kaszuba Kaszuba Kaszuba',
    },
    {
      id: '2',
      text: 'Abagael Lapadula Lapadula Lapadula Lapadula',
    },
    {
      id: '3',
      text: 'Abagael Lavecchia Lavecchia Lavecchia Lavecchia',
    },
    {
      id: '4',
      text: 'Fernando Navalón Navalón Navalón',
    },
    {
      id: '5',
      text: 'Willy Mantenimiento',
    },
  ];

  @Watch('search')
  private watchSearch(newVal: string, oldVal: string) {
    this.filteredOptions = this.searchOptions.filter((option) => option.text.toLowerCase().includes(newVal) );
  }

  private optionSelected(option: any) {
    alert(option.text);
  }
}
